export type GuaranteeDescriptionContent =
  | { mode: "html"; value: string }
  | { mode: "markdown"; value: string };

const RICH_HTML_TAG_PATTERN =
  /<\/?(strong|em|b|i|u|s|ul|ol|li|h[1-6]|blockquote|a|span)(\s|>|\/)/i;

const MARKDOWN_SYNTAX_PATTERN =
  /(^|\n)\s{0,3}#{1,6}\s|\*\*[^*]+\*\*|(^|\n)\s{0,3}[-*+]\s+\S|(^|\n)\s{0,3}\d+\.\s+\S|(^|\n)\s{0,3}>\s+\S/;

const PARAGRAPH_WRAPPER_PATTERN = /<\/?p\b|<\s*br\b/i;

export function resolveGuaranteeDescriptionContent(
  description: string
): GuaranteeDescriptionContent | null {
  const trimmed = description.trim();

  if (!trimmed) {
    return null;
  }

  const unwrapped = PARAGRAPH_WRAPPER_PATTERN.test(trimmed)
    ? unwrapParagraphHtmlToText(trimmed)
    : trimmed;

  if (RICH_HTML_TAG_PATTERN.test(trimmed) && !MARKDOWN_SYNTAX_PATTERN.test(unwrapped)) {
    return { mode: "html", value: trimmed };
  }

  if (MARKDOWN_SYNTAX_PATTERN.test(unwrapped)) {
    return { mode: "markdown", value: unwrapped };
  }

  return { mode: "html", value: toGuaranteeDescriptionHtml(unwrapped) };
}

export function toGuaranteeDescriptionHtml(description: string): string {
  const trimmed = description.trim();

  if (!trimmed) {
    return "";
  }

  if (RICH_HTML_TAG_PATTERN.test(trimmed) || PARAGRAPH_WRAPPER_PATTERN.test(trimmed)) {
    return trimmed;
  }

  return trimmed
    .split(/\n{2,}/)
    .map((paragraph) => {
      const withBreaks = escapeHtml(paragraph).replace(/\n/g, "<br />");
      return `<p>${withBreaks}</p>`;
    })
    .join("");
}

export function unwrapParagraphHtmlToText(html: string): string {
  return html
    .replace(/<p><br\s*\/?><\/p>/gi, "\n\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<p>/gi, "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/&nbsp;/gi, " ")
    .replace(/&gt;/g, ">")
    .replace(/&lt;/g, "<")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
